var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}},[_c('card-user')],1),_c('v-col',{attrs:{"cols":"8"}},[_c('card-data')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }